// extracted by mini-css-extract-plugin
module.exports = {"shoplist_tr":"table-row_shoplist_tr__3P2IR","shoplist_tr_controllers":"table-row_shoplist_tr_controllers__1OGq9"};